import React from "react";
import cx from "classnames";
import BarsIcon from "./BarsIcon";

type HamburgerButtonProps = {
  isOpen: boolean;
  onClick: (event: React.MouseEvent) => void;
};

const HamburgerButton: React.FC<HamburgerButtonProps> = ({
  isOpen,
  onClick,
}: HamburgerButtonProps): React.ReactElement => (
  <div
    className={cx(
      [
        "julia-website-hamburger-button",
        "u-background-color-hamburger",
        "u-cursor-pointer",
        "u-position-fixed",
        "u-right-3xs",
        "u-top-3xs",
        "u-z-index-100",
      ],
      isOpen && "u-display-none",
    )}
    onClick={onClick}
    role="presentation"
  >
    <BarsIcon
      className={cx(["u-margin-left-xs", "u-margin-top-2xs"])}
      fill="white"
      height={21}
    />
  </div>
);

export default React.memo(HamburgerButton);
